module.exports = __webpack_public_path__ + "media/images/letter-O-cb6a3788e4ca35e412ed20d498165fa7.png";